import { requestForToken, onMessageListener } from "../../firebase-config";

const useFirebase = () => {
  const askForNotificationPermission = async (registration) => {
    const userAgent = navigator.userAgent.toLowerCase();
    const knownBrowser = !/edge|opr|opera|samsungbrowser/.test(userAgent);

    await requestForToken(registration)
      .then((currentToken) => {
        if (currentToken) {
          console.log("Current token for client: ", currentToken);
          localStorage.setItem("fcmToken", currentToken);
        }
      })
      .catch((err) => {
        console.log("An error occurred while retrieving token. ", err);
      });
  };

  if ("serviceWorker" in navigator) {
    navigator.serviceWorker.ready.then(async (registration) => {
      try {
        await askForNotificationPermission(registration);
      } catch (error) {
        console.error("An error occurred while retrieving token. ", error);
      }
    });
  }

  // Listen for incoming messages
  onMessageListener()
    .then((payload) => {
      console.log("Message received. ", payload);
      if (navigator.serviceWorker) {
        navigator.serviceWorker.getRegistration().then((registration) => {
          return registration.showNotification(payload.notification.title, {
            body: payload.notification.body,
            icon: payload.notification.icon,
            data: { url: payload.fcmOptions?.link },
          });
        });
      }
    })
    .catch((e) => {
      console.log(e, "errorOnMessageListener");
    });
};

export default useFirebase;
